import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityDateCell } from "./ApplyCloseEntityDateCell";

export const ApplyCloseEntityWorkEndDateCell = memo(
    function ApplyCloseEntityWorkEndDateCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityDateCell
                row={row}
                field="workDeliveryDate"
                addText="Add work end"
                placeholder="Work end..."
            />
        );
    },
);
